<template>
  <v-card :elevation="disponible ? '12' : '0'" :disabled="disponible ? false : true">
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="1">
          <v-row no-gutters>
            <v-img
              @click="gotoImageDetail(product)"
              max-width="100"
              contain
              :lazy-src="
							`https://www.radec.com.mx/sites/all/files/imagecache/product_list/productos/${product.MATNR}.jpg`
						"
              :src="
							`https://www.radec.com.mx/sites/all/files/productos/${product.MATNR}.jpg`
						"
              alt="RADEC"
            ></v-img>
          </v-row>
        </v-col>
        <v-col cols="7">
          <v-row no-gutters>
            <span
              class="pr-2 body-2 secondary--text font-weight-black text-truncate text-no-wrap"
            >{{ product.MATNR }}</span>
            <span
              class="body-2 secondary--text font-weight-black text-truncate text-no-wrap"
            >{{ product.MARCA1 }}</span>
            <span
              class="body-2 primary--text text-truncate text-no-wrap pl-2"
            >{{ product.SUBMARCA1 }}</span>
          </v-row>
          <v-row no-gutters>
            <span class="overline secondary--text text-truncate text-no-wrap">{{ product.ZTX70 }}</span>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4">
              <span class="secondary--text font-weight-black text-xs-center">
                Sugerido:
                {{(prefix ='$' +(precioProducto.PrecioSugerido * 1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') +' ')}}
              </span>
            </v-col>
            <v-col cols="4">
              <span class="secondary--text font-weight-black text-right">
                Mínimo:
                {{
                (prefix =
                '$' +
                (precioProducto.PrecioMinimo * 1)
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') +
                ' ')
                }}
              </span>
            </v-col>
            <v-col cols="4">
              <span class="secondary--text font-weight-black text-right">
                Precio:
                {{
                (prefix =
                '$' +
                (precioSeleccionado * 1)
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') +
                ' ')
                }}
                <v-icon
                  color="indigo"
                  @click="cambiarPrecio = !cambiarPrecio"
                  x-small
                >fas fa-retweet</v-icon>
                <v-text-field
                  type="number"
                  v-model="nuevoPrecio"
                  v-if="cambiarPrecio"
                  prepend-icon="fas fa-dollar-sign"
                  append-outer-icon="far fa-check-circle"
                  @click:append-outer="changePrice"
                ></v-text-field>
              </span>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="4">
              <span
                class="primary--text caption"
              >Última Cot:{{(prefix ='$' +(productoInterlocutor.UltimaCotizacionPrecio * 1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') +' ')}}</span>
            </v-col>
            <v-col cols="4">
              <span
                class="primary--text caption"
              >Última Venta:{{(prefix ='$' +(productoInterlocutor.UltimaVentaPrecio * 1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') +' ')}}</span>
            </v-col>
            <v-col cols="4">
              <span class="primary--text caption">Márgen: {{margenPorciento}}%</span>
            </v-col>
          </v-row>
          <v-row no-gutters></v-row>
        </v-col>
        <v-col cols="4">
          <v-row no-gutters class="overline">
            <template v-for="(item, i)  in existenciaCentros">
              <v-tooltip top :disabled="item.qty < cantidad" :key="`item-${i}`" v-if="item.enabled">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-btn
                      @click="agregaPartida(product)"
                      :key="`item-${i}`"
                      class="ma-1"
                      tile
                      x-small
                      cols="6"
                      v-if="item.enabled"
                      :text="item.qty >0 ? false : true"
                      :color="sucursalSelected ==  item.sucClave ? 'green lighten-1' : ''"
                      :disabled="item.qty < cantidad && (item.qty <1) || (sucursalSelected != '' && sucursalSelected !=  item.sucClave)"
                    >
                      <span class="primary--text">{{item.sucClave}}</span>
                      <span class="secondary--text pl-2">{{item.qty}}</span>
                    </v-btn>
                  </span>
                </template>
                <span>{{item.desc}}</span>
              </v-tooltip>
            </template>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    data: () => ({
      isDev: false,
      cambiarPrecio: false,
      nuevoPrecio: null,
      model: {
        selected: "",
        sucClave: ""
      },
      actualCotizacionPartida: {},
      actualCotizacion: {},
      productoInterlocutorSelected: {},
      precioProductoSelected: {
        PrecioSugerido: 0.0,
        PrecioMinimo: 0.0,
        CostoProducto: 0.0
      },

      cantidad: 1,

      existenciaCentros: [
        { sucClave: "CDG1", desc: "CLJ", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC02", desc: "16S", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC03", desc: "EJE", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC04", desc: "CEY", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC06", desc: "MTY", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC07", desc: "BUL", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC08", desc: "LAU", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC09", desc: "LEO", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC10", desc: "TIJ", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC11", desc: "TUL", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC12", desc: "CHI", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC13", desc: "TCE", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC14", desc: "MEX", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC15", desc: "VIL", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC16", desc: "PER", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC17", desc: "CAN", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC18", desc: "VER", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC19", desc: "MER", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC20", desc: "PUE", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC21", desc: "CDJ", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC22", desc: "SLP", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC23", desc: "ECA", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC24", desc: "QUE", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC25", desc: "HER", qty: 0, selected: 0, enabled: false },
        { sucClave: "SC26", desc: "TOR", qty: 0, selected: 0, enabled: false }
      ],
      isSheetEnable: false,
      cantSelected: "",
      sucuSelected: "",
      sucuList: [],
      disponible: false,
      precioSeleccionado: "",
      comentarios: "Estos son los comentarios...",
      userInfo: {}
    }),
    computed: {
      isCliente() {
        return this.$store.getters.isCliente;
      },
      actualInterlocutorDetalle() {
        return this.$store.getters.getActualCotizacionInterlocutorDetalle;
      },
      seleccion() {
        return _.filter(this.existenciaCentros, function(o) {
          return o.selected > 0;
        });
      },
      isDisponible() {
        if (this.disponible == true) return false;
        else return true;
      },
      productoInterlocutor() {
        return this.productoInterlocutorSelected;
      },
      precioProducto() {
        return this.precioProductoSelected;
      },
      margenNumero() {
        return (this.precioSeleccionado - this.precioProducto.CostoProducto)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      },
      margenPorciento() {
        let result =
          (this.precioSeleccionado * 100) / this.precioProducto.CostoProducto -
          100;
        return result.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      },
      sucursalSelected() {
        return this.$store.getters.getCotizadorConfigs.sucClaveSelected;
      }
    },
    props: ["product"],
    watch: {},
    created() {
      this.userInfo = this.$store.getters.userInfo;
      this.actualCotizacion = this.$store.getters.getActualCotization;
    },
    mounted() {
      let self = this;
      this.buscaValores();

      //console.log("Template partida cargada... Usuario: " + this.userInfo.Nombre);
      //console.log(this.actualCotizacion);
      this.actualCotizacionPartida.Interlocutor = this.actualCotizacion.Interlocutor;
      this.actualCotizacionPartida.EstadoId = 1;
      this.actualCotizacionPartida.EstadoTexto = "Se registra Partida";
      this.actualCotizacionPartida.IdCotizacion = this.actualCotizacion.IdCotizacion;
      this.actualCotizacionPartida.UsuarioRegistraNombre = this.userInfo.Nombre;
      this.actualCotizacionPartida.UsuarioRegistra = this.userInfo.claveUsuario;
      //console.log(this.actualCotizacionPartida);
      //console.log(this.userInfo);
      this.$store
        .dispatch("getPrecioProductoGeneral", self.product.MATNR)
        .then(e => {
          //console.log("Precio para productoGeneral ...");
          this.precioProductoSelected = e;
          this.precioSeleccionado = this.precioProductoSelected.PrecioSugerido;
          //Añadimos a partida actual los datos de CotizacionPrecioProducto
          this.actualCotizacionPartida.PrecioSugerido = this.precioProductoSelected.PrecioSugerido;
          this.actualCotizacionPartida.PrecioMinimo = this.precioProductoSelected.PrecioMinimo;
          this.actualCotizacionPartida.CostoProducto = this.precioProductoSelected.CostoProducto;
          this.actualCotizacionPartida.ProDescripcion = this.product.ZTX70;
          this.actualCotizacionPartida.ProClave = this.precioProductoSelected.ProClave;
        })
        .catch(e => {
          console.log(e);
        });

      this.$store
        .dispatch("getPrecioProductoInterlocutor", self.product.MATNR)
        .then(e => {
          //console.log("Precio para productoInterlocutor obtenido...");
          this.productoInterlocutorSelected = e;
          //console.log(this.productoInterlocutorSelected);
        })
        .catch(e => {
          console.log(e);
        });
    },
    methods: {
      gotoImageDetail(item) {
        let self = this;
        let r = item.MATNR;
        let desc = item.ZTX70;
        console.log(r);
        console.log(desc);
        this.$store.commit("updateRadecProductImageOptions", {
          dialog: true,
          matnr: r,
          desc: desc
        });
      },
      agregaPartida(item) {
        this.cantidad = 1;
        console.log("Partida Lista para enviar a WebService:");

        this.actualCotizacionPartida.SucClave = this.model.sucClave;
        this.actualCotizacionPartida.PiezasEnSelling = this.model.qty;
        this.actualCotizacionPartida.PrecioUnitario = this.precioSeleccionado;
        this.actualCotizacionPartida.Comentarios = this.comentarios;
        this.actualCotizacionPartida.CantidadPiezas = this.cantidad;
        this.actualCotizacionPartida.Margen = this.margenNumero;
        this.actualCotizacionPartida.SubTotal =
          this.precioSeleccionado * this.cantidad;
        //Listo para enviar a WebService
        console.log(`Item: ${item.MATNR} ${item.ZTX70}`);
        console.log(`Product: ${this.product.MATNR} ${this.product.ZTX70}`);
        console.log(
          `actualCotizacionPartida: ${this.actualCotizacionPartida.ProClave} ${this.actualCotizacionPartida.ProDescripcion}`
        );

        let textConcatenado = `Registrado ${this.cantidad}  ${this.actualCotizacionPartida.ProDescripcion} en ${this.model.sucClave}`;

        this.$store
          .dispatch("postCotizacionPartida", this.actualCotizacionPartida)
          .then(res => {
            console.log("Terminado OK...");
            this.$store.commit(
              "updateActualCotizacionSucClaveSelected",
              this.model.sucClave
            );
          })
          .catch(e => {
            console.log("Error");
            console.log(e);
          });

        this.$store.commit("changeSnackBarOptions", textConcatenado);
        console.log(this.actualCotizacionPartida);
      },
      changePrice() {
        console.log(
          `Cambiando precio... ${this.precioSeleccionado} ${this.nuevoPrecio} Costo: ${this.precioProducto.CostoProducto}`
        );
        this.precioSeleccionado = this.nuevoPrecio;
        this.cambiarPrecio = false;
      },
      masAplicaciones(item) {
        console.log("Consultar más aplicaciones... ");
      },

      validaCantidad() {
        console.log("Validar cantidad ");

        if (this.model != null) {
          if (this.cantidad > this.model.qty) {
            console.log(
              `Cantidad no permitida en: ${this.model.sucClave} ${this.model.qty} ${this.cantidad}`
            );
            this.cantidad = this.model.qty;
          }
          if (this.cantidad <= this.model.qty) {
            console.log(
              `Cantidad permitida en: ${this.model.sucClave} ${this.model.qty} ${this.cantidad}`
            );
          }
        } else {
          console.log("Model NULL");
        }
      },
      agregaCarrito(item) {
        this.$store.commit("updateProductoActual", {
          Enable: true,
          SKU: item.MATNR,
          Descripcion: item.ZTX70,
          Cantidad: 0
        });
      },
      verDetalle(item) {
        //this.$store.commit("updateDetalleProducto", item);
        console.log("Ver detalle del producto...");
      },
      buscaValores() {
        let result = [];
        let self = this;
        _.forEach(this.existenciaCentros, function(value, key) {
          //Convertimos a entero el valor de la existencia.
          let existencia = parseInt(self.product.EXISTENCIAS.CDG1);
          //Aqui añadir a disponibles Interlocutor SucClave
          if (
            existencia > 0 &&
            value.sucClave ==
              self.$store.getters.getActualCotizacionInterlocutorDetalle.SucClave
          ) {
            // console.log(
            //   "Se añadira + 1 a disponibles Interlocutor SucClave " +
            //     value.sucClave
            // );
            self.$store.getters.getCotizadorConfigs
              .disponibleInterlocutorSucClave++;
            // console.log(
            //   self.$store.getters.getCotizadorConfigs
            //     .disponibleInterlocutorSucClave
            // );
          }

          switch (value.sucClave) {
            case "CDG1":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.CDG1
              );
              if (self.actualInterlocutorDetalle.CDG1)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC02":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC02
              );
              if (self.actualInterlocutorDetalle.SC02)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC03":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC03
              );
              if (self.actualInterlocutorDetalle.SC03)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC04":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC04
              );
              if (self.actualInterlocutorDetalle.SC04)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC05":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC05
              );
              if (self.actualInterlocutorDetalle.SC05)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC06":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC06
              );
              if (self.actualInterlocutorDetalle.SC06)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC07":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC07
              );
              if (self.actualInterlocutorDetalle.SC07)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC08":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC08
              );
              if (self.actualInterlocutorDetalle.SC08)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC09":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC09
              );
              if (self.actualInterlocutorDetalle.SC09)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC10":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC10
              );
              if (self.actualInterlocutorDetalle.SC10)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC11":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC11
              );
              if (self.actualInterlocutorDetalle.SC11)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC12":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC12
              );
              if (self.actualInterlocutorDetalle.SC12)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC13":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC13
              );
              if (self.actualInterlocutorDetalle.SC13)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC14":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC14
              );
              if (self.actualInterlocutorDetalle.SC14)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC15":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC15
              );
              if (self.actualInterlocutorDetalle.SC15)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC16":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC16
              );
              if (self.actualInterlocutorDetalle.SC16)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC17":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC17
              );
              if (self.actualInterlocutorDetalle.SC17)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC18":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC18
              );
              if (self.actualInterlocutorDetalle.SC18)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC19":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC19
              );
              if (self.actualInterlocutorDetalle.SC19)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC20":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC20
              );
              if (self.actualInterlocutorDetalle.SC20)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC21":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC21
              );
              if (self.actualInterlocutorDetalle.SC21)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC22":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC22
              );
              if (self.actualInterlocutorDetalle.SC22)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC23":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC23
              );
              if (self.actualInterlocutorDetalle.SC23)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC24":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC24
              );
              if (self.actualInterlocutorDetalle.SC24)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC25":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC25
              );
              if (self.actualInterlocutorDetalle.SC25)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC26":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC26
              );
              if (self.actualInterlocutorDetalle.SC26)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC27":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC27
              );
              if (self.actualInterlocutorDetalle.SC27)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC28":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC28
              );
              if (self.actualInterlocutorDetalle.SC28)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC29":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC29
              );
              if (self.actualInterlocutorDetalle.SC29)
                self.existenciaCentros[key].enabled = true;
              break;
            case "SC30":
              self.existenciaCentros[key].qty = parseInt(
                self.product.EXISTENCIAS.SC30
              );
              if (self.actualInterlocutorDetalle.SC30)
                self.existenciaCentros[key].enabled = true;
              break;
          }
          //Validamos si se activo enable para dicho centro y si tiene disponiblidad...
          if (
            self.existenciaCentros[key].enabled == true &&
            self.existenciaCentros[key].qty > 0
          ) {
            //console.log(self.existenciaCentros);
            self.$store.commit("updateMayorDisponibilidad", value.sucClave);
          }
          //Validamos si tiene al menos un disponible...
          if (self.existenciaCentros[key].qty > 0) {
            self.disponible = true;
            //console.log(self.existenciaCentros[key]);
          }
        });
        let objeto = {
          product: self.product,
          existencia: self.existenciaCentros
        };
        this.$store.commit("insertIntoListaProductoDetalle", objeto);

        return result;
      }
    }
  };
</script>
